import { Toast } from 'ngx-toastr';

export abstract class SeahorseToastTemplate<TData> extends Toast<TData> {
  defaultToastClasses = 'ca-toast ngx-toastr';

  abstract toastClasses: string;
}
